
import React, { Component } from 'react';
import ThirdCom from '../ThirdCom';

/**
 * 单据审批
 */
class ApprovalModal extends Component {

    state = { show: this.props.show }

    static defaultProps = { show: false }

    static getDerivedStateFromProps(props) {
        return { show: props.show };
    }

    closeEvent = () => {
        let { close } = this.props;
        if (typeof close === "function") {
            close();
        }
        this.setState({ show: false });
    }

    render() {
        let { show } = this.state;
        return <ThirdCom
            {...this.props}
            showThirdComponent={show}
            close={this.closeEvent}
            componentNameSpace="uap/common/components/approveModal/index"
            componentPath="../../../../uap/common/components/approveModal/index.js"
            componentName='单据审批'
        />;
    }
}

export default ApprovalModal;
